module.exports = __webpack_public_path__ + "img/kkb_truss_circle_6m.016b56f4.png";